import { render, staticRenderFns } from "./brandProductList.vue?vue&type=template&id=c72e37dc"
import script from "./brandProductList.vue?vue&type=script&lang=js"
export * from "./brandProductList.vue?vue&type=script&lang=js"
import style0 from "./brandProductList.vue?vue&type=style&index=0&id=c72e37dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports